export enum SELECT_SHIPPING_METHOD_STATES {
  INITIAL = 'initial',
  WAITING_FOR_CART = 'WAITING_FOR_CART',
  CART_READY = 'CART_READY',
  GET = 'GET',
  METHODS_FETCHING = 'METHODS_FETCHING',
  GET_ERROR = 'ERROR',
  GET_SUCCESS = 'GET_SUCCESS',
  NO_SHIPPING_RECEIVED = 'NO_SHIPPING_RECEIVED',
  HOME_METHOD_SELECTED = 'HOME_METHOD_SELECTED',
  PICKUP_METHOD_SELECTED = 'PICKUP_METHOD_SELECTED',
  PICKUP_POINT_SELECTED = 'PICKUP_POINT_SELECTED',
  COURIER_METHOD_SELECTED = 'COURIER_METHOD_SELECTED',
  TIME_SLOT_SELECTED = 'TIME_SLOT_SELECTED',
  CLICK_AND_COLLECT_SELECTED = 'CLICK_AND_COLLECT_SELECTED',
  SHIPPING_METHOD_SELECTED = 'SHIPPING_METHOD_SELECTED',
}
